import React from 'react';
import { BRAND } from './index';

/**
 * Renders the active brand's wordmark as an inline element that inherits the
 * caller's font size (so it works in both the large login header and the small
 * nav bar). For 6love it renders the lockup — a green "6" followed by "love" —
 * per design-system/project/guidelines/brand-logo.card.html. For Tennis Team
 * Manager it renders the plain product name.
 */
export const Wordmark: React.FC<{ className?: string }> = ({ className }) => {
  if (!BRAND.useWordmark) {
    return <span className={className}>{BRAND.name}</span>;
  }

  // 6-love lockup: ExtraBold, tight tracking, the numeral "6" in brand green,
  // the "-love" in the inherited text color.
  return (
    <span
      className={className}
      style={{ fontWeight: 800, letterSpacing: '-0.03em' }}
      aria-label={BRAND.name}
    >
      <span style={{ color: '#18a75b' }}>6</span>
      <span>-love</span>
    </span>
  );
};
